import React from "react";

interface TextInputProps {
  label: string;
  name: string;
  value: string;
  para?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  optional?: boolean;
  widthLabel?: string;
  widthInput?: string;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  name,
  value,
  para,
  onChange,
  optional = false,
  widthLabel = "w-[35%]",
  widthInput = "w-[65%]",
}) => {
  return (
    <div className="flex mb-2 md:mb-4">
      <div className={`${widthLabel}`}>
        <label className="mb-1 md:mb-2">
          {label}
          {!optional && <span className="text-red-500">*</span>}
          {optional && (
            <span className="text-gray-400 text-xs"> Optional</span>
          )}
        </label>
        {para && <p className="text-xs md:text-sm">{para}</p>}
      </div>
      <input
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        className={`border-2 text-xs md:text-sm p-2 rounded-md ${widthInput} focus:outline-none focus:border-[#2fa9bf]`}
      />
    </div>
  );
};

export default TextInput;
